export default function Dashboard() {
  return (
    <div>
      <h1 className="text-xl font-bold mb-4">Dashboard</h1>
      {/* અહીં તમારું dashboard content */}
      <div className="grid grid-cols-3 gap-4">
        <div className="bg-green-100 p-4 rounded">Today's Enquiries: 0</div>
        <div className="bg-yellow-100 p-4 rounded">Today's Follow-ups: 0</div>
        <div className="bg-blue-100 p-4 rounded">Upcoming Follow-ups: 0</div>
      </div>
    </div>
  );
}
